module.exports = __webpack_public_path__ + "static/img/img-submit-success.d7ef43be.png";